import { Response } from '@marketplace-web/shared/api-client'

import { PickUpParcelCodeResponse } from 'types/api/response/pick-up-parcel-code-response'

import { transformPickUpParcelCode } from 'data/transformers/pickup-parcel'

export const transformPickUpParcelCodeResponse = (response: Response<PickUpParcelCodeResponse>) =>
  transformPickUpParcelCode(response.parcel_collection_code)
